import React from "react";
import BroadcastSelectedProjects from "../../Broadcast/BroadcastSelectedProjects";
import { pageProps } from "../../helpers/pageProps";
import MyModal from "../MyModal";
import ProjectInputVariables from "../ProjectInputVariables";
import HelpButton from "../../HelpContent/HelpButton";

export default function ApiModalProjects({
  api,
  onChange,
  backendErrors,
}: {
  api: any;
  onChange: (newApi: any) => void;
  backendErrors?: any;
}) {
  return (
    <div className="my-4">
      <div className="bg-purple-gradient-darker-reverse rounded-4 p-3">
        <h5 className="">Logic project</h5>
        {backendErrors?.["ApiConnection.Triggers"] && (
          <div className="alert alert-warning">
            {backendErrors["ApiConnection.Triggers"]}
            <br />
            A Project must be selected before the API Connection can be saved
          </div>
        )}
        <BroadcastSelectedProjects
          selected={api.Triggers?.map((t: any) => t.CallUuid) || []}
          onSelect={(p) => {
            const prevTriggers = api.Triggers || [];
            onChange({
              ...api,
              Triggers: prevTriggers.some((t: any) => t.CallUuid === p?.UUID)
                ? prevTriggers.filter((t: any) => t.CallUuid !== p?.UUID)
                : [
                    ...prevTriggers,
                    {
                      CallType: "component",
                      CallUuid: p?.UUID,
                      Reference: p?.Reference || "",
                      Project: p,
                    },
                  ],
            });
          }}
          useUuid
          extraFields={(p: { Reference: string; UUID: string }) => (
            <>
              {api.Uuid ? (
                <div
                  className="text-secondary small"
                  style={{ cursor: "text", userSelect: "all" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {pageProps.inboundApiBase}/{api.Uuid}/{p.Reference}
                </div>
              ) : (
                <div className="text-secondary small">
                  The endpoint will appear here once you save the API.
                </div>
              )}

              <div
                onClick={(e) => e.stopPropagation()}
                className="d-inline-block"
              >
                <MyModal
                  heading={
                    <>
                      API payload example <HelpButton helpKey="api-payload-example" />
                    </>
                  }
                  size="lg"
                  label="API payload example"
                  buttonClassName="btn btn-link"
                  className="z-4000"
                  backdropClassName="z-3999"
                >
                  <ProjectInputVariables uuid={p.UUID} />
                </MyModal>
              </div>
            </>
          )}
        />
      </div>
    </div>
  );
}
